import * as d3 from 'd3';

// A real, interactive hover tooltip (native SVG <title> is slow and only triggers
// on a precise hover over the glyph — PRD-1370 #20). Anchors an absolutely-positioned
// div to the chart's positioned container and follows the cursor. Styles are inline
// so it works wherever a renderer is used, with no CSS import to remember.
export function ensureTooltip(container) {
  if (!container) return { show() {}, hide() {} };
  if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
  let el = container.querySelector(':scope > .wc-chart-tooltip');
  if (!el) {
    el = document.createElement('div');
    el.className = 'wc-chart-tooltip';
    Object.assign(el.style, {
      position: 'absolute',
      pointerEvents: 'none',
      background: 'rgba(33,33,33,0.92)',
      color: '#fff',
      font: '11px Roboto, sans-serif',
      padding: '4px 8px',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
      transform: 'translate(-50%, -130%)',
      transition: 'opacity 0.08s',
      opacity: '0',
      zIndex: '10',
    });
    container.appendChild(el);
  }
  return {
    show(text, event) {
      const [x, y] = d3.pointer(event, container);
      el.textContent = text;
      el.style.left = `${x}px`;
      el.style.top = `${y}px`;
      el.style.opacity = '1';
    },
    hide() {
      el.style.opacity = '0';
    },
  };
}
